import React from "react";

import { LANGUAGES, STAGES, STAGE_CHANNELS, channelLabel, stageLabel } from "../../campaignUtils";
import { Tabs } from "../../shared/StudioControls";

const Writing = () => (
  <React.Fragment>
    <span className="cs-tabs__pending" aria-hidden="true">…</span>
    <span className="cs-visually-hidden">, still writing</span>
  </React.Fragment>
);

// Stage → channel → language picker shared by the editor and the test step.
// While AI is generating, pass the selected channels/languages so unwritten tabs still show.
export const VariantTabs = ({ content, stage, channel, language, channels, languages, isWriting, onStageChange, onChannelChange, onLanguageChange }) => {
  const stageIndex = STAGES.indexOf(stage);
  const variants = (content[stageIndex] || {}).variants || {};
  const scheduledChannel = STAGE_CHANNELS[stageIndex];
  const visibleLanguages = (languages || Object.keys(variants[channel] || {}))
    .filter(item => LANGUAGES.includes(item));
  const mark = (label, writing) => (writing ? <React.Fragment>{label}<Writing /></React.Fragment> : label);
  return (
    <div className="cs-variant-tabs">
      <Tabs
        label="Notification day"
        values={STAGES}
        value={stage}
        onChange={onStageChange}
        format={item => mark(stageLabel(item), isWriting && isWriting(item, channel, language))}
      />
      <div className="cs-variant-tabs__row">
        <Tabs
          label="Channel"
          values={[scheduledChannel]}
          value={scheduledChannel}
          onChange={onChannelChange}
          format={item => mark(channelLabel(item), isWriting && isWriting(stage, item, language))}
        />
        <Tabs
          label="Language"
          values={visibleLanguages}
          value={language}
          onChange={onLanguageChange}
          format={item => mark(item, isWriting && isWriting(stage, channel, item))}
        />
      </div>
    </div>
  );
};
